
// Global vars

// Horizontal page nav
const biro_pnh            = document.querySelector( '#page-nav-horizontal' );
const biro_pnh_toggle     = document.querySelector( '#page-nav-toggle' );
const biro_pnh_list       = document.querySelector( '#page-nav-list' );
const biro_pnh_next_block = biro_pnh ? biro_pnh.nextElementSibling : null;
